import type { TextInputProps } from '@components/input/text-input'
import { TextInput } from '@components/input/text-input'
import { TEXT } from '@lib/utils/text'
import { COUNTRY_CODE, COUNTRY_PREFIX, PHONE_FORMAT } from '@shared/util/phone'
import { forwardRef } from 'react'
import type { FunctionComponent } from 'react'
import { PatternFormat } from 'react-number-format'

/** US telephone input with mask and formatting. */
export const TelephoneInput: FunctionComponent<
    React.PropsWithChildren<TelephoneInputProps>
> = forwardRef<HTMLInputElement, TelephoneInputProps>(
    (
        {
            size,
            displayOnLight = false,
            placeholder = TEXT.phoneNumber,
            onFocus,
            onBlur,
            ...restOfProps
        },
        ref,
    ) => (
        <PatternFormat
            {...restOfProps}
            size={size}
            type='tel'
            getInputRef={ref}
            prefix={COUNTRY_PREFIX}
            format={PHONE_FORMAT}
            customInput={TextInput}
            placeholder={placeholder}
            allowEmptyFormatting={false}
            onFocus={onFocus}
            onBlur={onBlur}
            displayOnLight={displayOnLight}
        />
    ),
)

export const CountryCode: FunctionComponent = () => (
    <>
        ({COUNTRY_CODE})<b>&nbsp;{COUNTRY_PREFIX}</b>
    </>
)

export type TelephoneInputProps = Omit<TextInputProps, 'type'> & {
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
    displayOnLight?: boolean
}
